export const materials = [
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/SsQUxuoD.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_zewendong_",
		"material_type": "bgimg",
		"name": "bg_zewendong_",
		"cover_url": require("@/assets/images/bgImg/1.jpg"),
		"status": 1,
		"priority": 4,
		"created_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"cname": "简约时尚",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/17THlmfs.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_lanzijinran_1920x1080",
		"material_type": "bgimg",
		"name": "bg_lanzijinran_1920x1080",
		"cover_url": require("@/assets/images/bgImg/2.jpg"),
		"status": 1,
		"priority": 5,
		"created_at": {
			"seconds": "1688550147",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688550147",
			"nanos": 0
		},
		"cname": "蓝紫浸染",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/gY32EV4x.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_litikongjian_1920x1080",
		"material_type": "bgimg",
		"name": "bg_litikongjian_1920x1080",
		"cover_url": require("@/assets/images/bgImg/3.jpg"),
		"status": 1,
		"priority": 6,
		"created_at": {
			"seconds": "1688550022",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688550022",
			"nanos": 0
		},
		"cname": "立体空间",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/xiMOilr7.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_huazhi_1920x1080",
		"material_type": "bgimg",
		"name": "bg_huazhi_1920x1080",
		"cover_url": require("@/assets/images/bgImg/4.jpg"),
		"status": 1,
		"priority": 7,
		"created_at": {
			"seconds": "1688549915",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549915",
			"nanos": 0
		},
		"cname": "画纸",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/XB0o72LG.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_xiguahongjianbian_1920x1080",
		"material_type": "bgimg",
		"name": "bg_xiguahongjianbian_1920x1080",
		"cover_url": require("@/assets/images/bgImg/5.jpg"),
		"status": 1,
		"priority": 8,
		"created_at": {
			"seconds": "1688549861",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549861",
			"nanos": 0
		},
		"cname": "西瓜红渐变",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/nJ3J8g3H.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_lansebowen_1920x1080",
		"material_type": "bgimg",
		"name": "bg_lansebowen_1920x1080",
		"cover_url": require("@/assets/images/bgImg/6.jpg"),
		"status": 1,
		"priority": 9,
		"created_at": {
			"seconds": "1688549782",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549782",
			"nanos": 0
		},
		"cname": "蓝色波纹",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/SsD5U8x0.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_keaipaopao_1920x1080",
		"material_type": "bgimg",
		"name": "bg_keaipaopao_1920x1080",
		"cover_url": require("@/assets/images/bgImg/14.jpg"),
		"status": 1,
		"priority": 10,
		"created_at": {
			"seconds": "1688549706",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549712",
			"nanos": 0
		},
		"cname": "可爱泡泡",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/4PsIkjOD.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_bolixiaoguo_1920x1080",
		"material_type": "bgimg",
		"name": "bg_bolixiaoguo_1920x1080",
		"cover_url": require("@/assets/images/bgImg/7.jpg"),
		"status": 1,
		"priority": 11,
		"created_at": {
			"seconds": "1688549638",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549638",
			"nanos": 0
		},
		"cname": "玻璃效果",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/iH11xkSl.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_shangwuyuanquan_1920x1080",
		"material_type": "bgimg",
		"name": "bg_shangwuyuanquan_1920x1080",
		"cover_url": require("@/assets/images/bgImg/8.jpg"),
		"status": 1,
		"priority": 12,
		"created_at": {
			"seconds": "1688549566",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549566",
			"nanos": 0
		},
		"cname": "商务圆圈",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/CJNi3sUu.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_lansewangge_1920x1080",
		"material_type": "bgimg",
		"name": "bg_lansewangge_1920x1080",
		"cover_url": require("@/assets/images/bgImg/9.jpg"),
		"status": 1,
		"priority": 13,
		"created_at": {
			"seconds": "1688549451",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688549451",
			"nanos": 0
		},
		"cname": "蓝色网格",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/0d5RI0Zv.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "bg_anhuang_1920x1080",
		"material_type": "bgimg",
		"name": "bg_anhuang_1920x1080",
		"cover_url": require("@/assets/images/bgImg/10.jpg"),
		"status": 1,
		"priority": 14,
		"created_at": {
			"seconds": "1688543606",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688543606",
			"nanos": 0
		},
		"cname": "暗黄",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/HENRDDdL.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "bg_minglianglv_1920x1080",
		"material_type": "bgimg",
		"name": "bg_minglianglv_1920x1080",
		"cover_url":require("@/assets/images/bgImg/11.jpg"),
		"status": 1,
		"priority": 15,
		"created_at": {
			"seconds": "1688543553",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688543553",
			"nanos": 0
		},
		"cname": "明亮绿",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/RvWllDtG.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "bg_fenpao_1920x1080",
		"material_type": "bgimg",
		"name": "bg_fenpao_1920x1080",
		"cover_url": require("@/assets/images/bgImg/12.jpg"),
		"status": 1,
		"priority": 16,
		"created_at": {
			"seconds": "1688543487",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688543487",
			"nanos": 0
		},
		"cname": "粉泡",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/cj31natP.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "bg_jianbianlv_1920x1080",
		"material_type": "bgimg",
		"name": "bg_jianbianlv_1920x1080",
		"cover_url": require("@/assets/images/bgImg/13.jpg"),
		"status": 1,
		"priority": 17,
		"created_at": {
			"seconds": "1688543432",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1688543502",
			"nanos": 0
		},
		"cname": "渐变绿",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
]

export const customMaterials = [
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/framebackground24_1650012850_1659688486.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "xy_material_7wqxplg6rg7sot5r2o539m4",
		"material_type": "bgimg",
		"name": "zhiying_frame_background_framebackground24",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/4AzcvZf7.jpeg",
		"status": 1,
		"priority": 95,
		"created_at": {
			"seconds": "1659688486",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1660644408",
			"nanos": 0
		},
		"cname": "bg24",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/framebackground25_1650012851_1659688517.png"
		},
		"asset_extend_details": {},
		"material_id": "xy_material_69wpe27ln6jsosv8qxgvo0z",
		"material_type": "bgimg",
		"name": "zhiying_frame_background_framebackground25",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/EjfGxfLk.png",
		"status": 1,
		"priority": 96,
		"created_at": {
			"seconds": "1659688518",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1660644418",
			"nanos": 0
		},
		"cname": "bg25",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/framebackground26_1650012852_1659688483.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "xy_material_odqgwvpyrw5sytyr507zlk6",
		"material_type": "bgimg",
		"name": "zhiying_frame_background_framebackground26",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/P1zKZBLY.jpeg",
		"status": 1,
		"priority": 97,
		"created_at": {
			"seconds": "1659688483",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1660644431",
			"nanos": 0
		},
		"cname": "bg26",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	},
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/framebackground27_1650012853_1659688480.jpeg"
		},
		"asset_extend_details": {},
		"material_id": "xy_material_veo502zynv2s3td8pl67dqj",
		"material_type": "bgimg",
		"name": "zhiying_frame_background_framebackground27",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/wlpwooiP.jpeg",
		"status": 1,
		"priority": 98,
		"created_at": {
			"seconds": "1659688481",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1660643868",
			"nanos": 0
		},
		"cname": "bg27",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	}
]

export const colors = [
  {
    "cate": [],
    "asset_details": {
      "color": "#F26522",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f26522",
    "material_type": "bgcolor",
    "name": "#f26522",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 1,
    "created_at": {
      "seconds": "1698291718",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995720",
      "nanos": 0
    },
    "cname": "#f26522",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#ED1941",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#ed1941",
    "material_type": "bgcolor",
    "name": "#ed1941",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 2,
    "created_at": {
      "seconds": "1698291682",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995851",
      "nanos": 0
    },
    "cname": "#ed1941",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#AA363D",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#aa363d",
    "material_type": "bgcolor",
    "name": "#aa363d",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 3,
    "created_at": {
      "seconds": "1698291522",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995860",
      "nanos": 0
    },
    "cname": "#aa363d",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#A7324A",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#a7324a",
    "material_type": "bgcolor",
    "name": "#a7324a",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 4,
    "created_at": {
      "seconds": "1698291472",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995843",
      "nanos": 0
    },
    "cname": "#a7324a",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B22C46",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#b22c46",
    "material_type": "bgcolor",
    "name": "#b22c46",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 5,
    "created_at": {
      "seconds": "1698291428",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995835",
      "nanos": 0
    },
    "cname": "#b22c46",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#973C3F",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#973c3f",
    "material_type": "bgcolor",
    "name": "#973c3f",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 6,
    "created_at": {
      "seconds": "1698291381",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995868",
      "nanos": 0
    },
    "cname": "#973c3f",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#AC6767",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#ac6767",
    "material_type": "bgcolor",
    "name": "#ac6767",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 7,
    "created_at": {
      "seconds": "1698291325",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995818",
      "nanos": 0
    },
    "cname": "#ac6767",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#987165",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#987165",
    "material_type": "bgcolor",
    "name": "#987165",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 8,
    "created_at": {
      "seconds": "1698215823",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995810",
      "nanos": 0
    },
    "cname": "#987165",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#BB505D",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#bb505d",
    "material_type": "bgcolor",
    "name": "#bb505d",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 9,
    "created_at": {
      "seconds": "1698215776",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995827",
      "nanos": 0
    },
    "cname": "#bb505d",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#C76968",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#c76968",
    "material_type": "bgcolor",
    "name": "#c76968",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 10,
    "created_at": {
      "seconds": "1698215672",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995802",
      "nanos": 0
    },
    "cname": "#c76968",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B3424A",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#b3424a",
    "material_type": "bgcolor",
    "name": "#b3424a",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 11,
    "created_at": {
      "seconds": "1698215498",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995791",
      "nanos": 0
    },
    "cname": "#b3424a",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D93A49",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#d93a49",
    "material_type": "bgcolor",
    "name": "#d93a49",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 12,
    "created_at": {
      "seconds": "1698215396",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1705995780",
      "nanos": 0
    },
    "cname": "#d93a49",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D64F44",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#d64f44",
    "material_type": "bgcolor",
    "name": "#d64f44",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 13,
    "created_at": {
      "seconds": "1698134878",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134878",
      "nanos": 0
    },
    "cname": "#d64f44",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D71345",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#d71345",
    "material_type": "bgcolor",
    "name": "#d71345",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 14,
    "created_at": {
      "seconds": "1698134832",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134832",
      "nanos": 0
    },
    "cname": "#d71345",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#BD6758",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#bd6758",
    "material_type": "bgcolor",
    "name": "#bd6758",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 15,
    "created_at": {
      "seconds": "1698134812",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134812",
      "nanos": 0
    },
    "cname": "#bd6758",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F391A9",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f391a9",
    "material_type": "bgcolor",
    "name": "#f391a9",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 16,
    "created_at": {
      "seconds": "1698134749",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134749",
      "nanos": 0
    },
    "cname": "#f391a9",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#CA8687",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#ca8687",
    "material_type": "bgcolor",
    "name": "#ca8687",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 17,
    "created_at": {
      "seconds": "1698134711",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134711",
      "nanos": 0
    },
    "cname": "#ca8687",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F58F98",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f58f98",
    "material_type": "bgcolor",
    "name": "#f58f98",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 18,
    "created_at": {
      "seconds": "1698134247",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134247",
      "nanos": 0
    },
    "cname": "#f58f98",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F69C9F",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f69c9f",
    "material_type": "bgcolor",
    "name": "#f69c9f",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 19,
    "created_at": {
      "seconds": "1698134215",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134215",
      "nanos": 0
    },
    "cname": "#f69c9f",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F8ABA6",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f8aba6",
    "material_type": "bgcolor",
    "name": "#f8aba6",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 20,
    "created_at": {
      "seconds": "1698134185",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134185",
      "nanos": 0
    },
    "cname": "#f8aba6",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "url": "",
      "color": "#F15B6C"
    },
    "asset_extend_details": {},
    "material_id": "#f15b6c",
    "material_type": "bgcolor",
    "name": "#f15b6c",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 21,
    "created_at": {
      "seconds": "1698134143",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134143",
      "nanos": 0
    },
    "cname": "#f15b6c",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FEEEED",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#feeeed",
    "material_type": "bgcolor",
    "name": "#feeeed",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 22,
    "created_at": {
      "seconds": "1698134078",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134078",
      "nanos": 0
    },
    "cname": "#feeeed",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#EF5B9C",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#ef5b9c",
    "material_type": "bgcolor",
    "name": "#ef5b9c",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 23,
    "created_at": {
      "seconds": "1698134049",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134049",
      "nanos": 0
    },
    "cname": "#ef5b9c",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F7ACBC",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "#f7acbc",
    "material_type": "bgcolor",
    "name": "#f7acbc",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 24,
    "created_at": {
      "seconds": "1698134009",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1698134009",
      "nanos": 0
    },
    "cname": "#f7acbc",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#55813a",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "55813a",
    "material_type": "bgcolor",
    "name": "#55813a",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 25,
    "created_at": {
      "seconds": "1697622219",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697622219",
      "nanos": 0
    },
    "cname": "#55813a",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#dde563",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "dde563",
    "material_type": "bgcolor",
    "name": "#dde563",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 26,
    "created_at": {
      "seconds": "1697622250",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697622250",
      "nanos": 0
    },
    "cname": "#dde563",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#c16f15",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "c16f15",
    "material_type": "bgcolor",
    "name": "#c16f15",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 27,
    "created_at": {
      "seconds": "1697622271",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697622271",
      "nanos": 0
    },
    "cname": "#c16f15",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#95b754",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "95b754",
    "material_type": "bgcolor",
    "name": "#95b754",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 28,
    "created_at": {
      "seconds": "1697622291",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697622291",
      "nanos": 0
    },
    "cname": "#95b754",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#a2b289",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "a2b289",
    "material_type": "bgcolor",
    "name": "#a2b289",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 29,
    "created_at": {
      "seconds": "1697622321",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697622321",
      "nanos": 0
    },
    "cname": "#a2b289",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D910E0",
      "url": ""
    },
    "asset_extend_details": {},
    "material_id": "D910E0",
    "material_type": "bgcolor",
    "name": "#D910E0",
    "cover_url": "https://material.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 30,
    "created_at": {
      "seconds": "1697535947",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1697535947",
      "nanos": 0
    },
    "cname": "#D910E0",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#ffffff"
    },
    "asset_extend_details": {},
    "material_id": "ffffff",
    "material_type": "bgcolor",
    "name": "#ffffff",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 31,
    "created_at": {
      "seconds": "1663571804",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571804",
      "nanos": 0
    },
    "cname": "#ffffff",
    "description": "#ffffff",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#878787"
    },
    "asset_extend_details": {},
    "material_id": "878787",
    "material_type": "bgcolor",
    "name": "#878787",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 32,
    "created_at": {
      "seconds": "1663571805",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571805",
      "nanos": 0
    },
    "cname": "#878787",
    "description": "#878787",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#C0C1C0"
    },
    "asset_extend_details": {},
    "material_id": "C0C1C0",
    "material_type": "bgcolor",
    "name": "#C0C1C0",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 33,
    "created_at": {
      "seconds": "1663571805",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571805",
      "nanos": 0
    },
    "cname": "#C0C1C0",
    "description": "#C0C1C0",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#535353"
    },
    "asset_extend_details": {},
    "material_id": "535353",
    "material_type": "bgcolor",
    "name": "#535353",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 34,
    "created_at": {
      "seconds": "1663571817",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571817",
      "nanos": 0
    },
    "cname": "#535353",
    "description": "#535353",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#000"
    },
    "asset_extend_details": {},
    "material_id": "000",
    "material_type": "bgcolor",
    "name": "#000",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 35,
    "created_at": {
      "seconds": "1663571818",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571818",
      "nanos": 0
    },
    "cname": "#000",
    "description": "#000",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FEC0C8"
    },
    "asset_extend_details": {},
    "material_id": "FEC0C8",
    "material_type": "bgcolor",
    "name": "#FEC0C8",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 36,
    "created_at": {
      "seconds": "1663571819",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571819",
      "nanos": 0
    },
    "cname": "#FEC0C8",
    "description": "#FEC0C8",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FB746D"
    },
    "asset_extend_details": {},
    "material_id": "FB746D",
    "material_type": "bgcolor",
    "name": "#FB746D",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 37,
    "created_at": {
      "seconds": "1663571820",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571820",
      "nanos": 0
    },
    "cname": "#FB746D",
    "description": "#FB746D",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FB3841"
    },
    "asset_extend_details": {},
    "material_id": "FB3841",
    "material_type": "bgcolor",
    "name": "#FB3841",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 38,
    "created_at": {
      "seconds": "1663571821",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571821",
      "nanos": 0
    },
    "cname": "#FB3841",
    "description": "#FB3841",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#820026"
    },
    "asset_extend_details": {},
    "material_id": "820026",
    "material_type": "bgcolor",
    "name": "#820026",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 39,
    "created_at": {
      "seconds": "1663571822",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571822",
      "nanos": 0
    },
    "cname": "#820026",
    "description": "#820026",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E0002F"
    },
    "asset_extend_details": {},
    "material_id": "E0002F",
    "material_type": "bgcolor",
    "name": "#E0002F",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 40,
    "created_at": {
      "seconds": "1663571822",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571822",
      "nanos": 0
    },
    "cname": "#E0002F",
    "description": "#E0002F",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FED0BA"
    },
    "asset_extend_details": {},
    "material_id": "FED0BA",
    "material_type": "bgcolor",
    "name": "#FED0BA",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 41,
    "created_at": {
      "seconds": "1663571823",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571823",
      "nanos": 0
    },
    "cname": "#FED0BA",
    "description": "#FED0BA",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FDA17A"
    },
    "asset_extend_details": {},
    "material_id": "FDA17A",
    "material_type": "bgcolor",
    "name": "#FDA17A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 42,
    "created_at": {
      "seconds": "1663571824",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571824",
      "nanos": 0
    },
    "cname": "#FDA17A",
    "description": "#FDA17A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#EF5507"
    },
    "asset_extend_details": {},
    "material_id": "EF5507",
    "material_type": "bgcolor",
    "name": "#EF5507",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 43,
    "created_at": {
      "seconds": "1663571825",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571825",
      "nanos": 0
    },
    "cname": "#EF5507",
    "description": "#EF5507",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FC7632"
    },
    "asset_extend_details": {},
    "material_id": "FC7632",
    "material_type": "bgcolor",
    "name": "#FC7632",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 44,
    "created_at": {
      "seconds": "1663571825",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571825",
      "nanos": 0
    },
    "cname": "#FC7632",
    "description": "#FC7632",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#99262A"
    },
    "asset_extend_details": {},
    "material_id": "99262A",
    "material_type": "bgcolor",
    "name": "#99262A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 45,
    "created_at": {
      "seconds": "1663571826",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571826",
      "nanos": 0
    },
    "cname": "#99262A",
    "description": "#99262A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FFF9B7"
    },
    "asset_extend_details": {},
    "material_id": "FFF9B7",
    "material_type": "bgcolor",
    "name": "#FFF9B7",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 46,
    "created_at": {
      "seconds": "1663571827",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571827",
      "nanos": 0
    },
    "cname": "#FFF9B7",
    "description": "#FFF9B7",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FEFF7B"
    },
    "asset_extend_details": {},
    "material_id": "FEFF7B",
    "material_type": "bgcolor",
    "name": "#FEFF7B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 47,
    "created_at": {
      "seconds": "1663571828",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571828",
      "nanos": 0
    },
    "cname": "#FEFF7B",
    "description": "#FEFF7B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#FDAF0A"
    },
    "asset_extend_details": {},
    "material_id": "FDAF0A",
    "material_type": "bgcolor",
    "name": "#FDAF0A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 48,
    "created_at": {
      "seconds": "1663571829",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571829",
      "nanos": 0
    },
    "cname": "#FDAF0A",
    "description": "#FDAF0A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F9D35B"
    },
    "asset_extend_details": {},
    "material_id": "F9D35B",
    "material_type": "bgcolor",
    "name": "#F9D35B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 49,
    "created_at": {
      "seconds": "1663571829",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571829",
      "nanos": 0
    },
    "cname": "#F9D35B",
    "description": "#F9D35B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#996127"
    },
    "asset_extend_details": {},
    "material_id": "996127",
    "material_type": "bgcolor",
    "name": "#996127",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 50,
    "created_at": {
      "seconds": "1663571830",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571830",
      "nanos": 0
    },
    "cname": "#996127",
    "description": "#996127",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F7BBDA"
    },
    "asset_extend_details": {},
    "material_id": "F7BBDA",
    "material_type": "bgcolor",
    "name": "#F7BBDA",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 51,
    "created_at": {
      "seconds": "1663571831",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571831",
      "nanos": 0
    },
    "cname": "#F7BBDA",
    "description": "#F7BBDA",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E44583"
    },
    "asset_extend_details": {},
    "material_id": "E44583",
    "material_type": "bgcolor",
    "name": "#E44583",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 52,
    "created_at": {
      "seconds": "1663571832",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571832",
      "nanos": 0
    },
    "cname": "#E44583",
    "description": "#E44583",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#F081B2"
    },
    "asset_extend_details": {},
    "material_id": "F081B2",
    "material_type": "bgcolor",
    "name": "#F081B2",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 53,
    "created_at": {
      "seconds": "1663571832",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571832",
      "nanos": 0
    },
    "cname": "#F081B2",
    "description": "#F081B2",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#C10066"
    },
    "asset_extend_details": {},
    "material_id": "C10066",
    "material_type": "bgcolor",
    "name": "#C10066",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 54,
    "created_at": {
      "seconds": "1663571833",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571833",
      "nanos": 0
    },
    "cname": "#C10066",
    "description": "#C10066",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#7C0F3B"
    },
    "asset_extend_details": {},
    "material_id": "7C0F3B",
    "material_type": "bgcolor",
    "name": "#7C0F3B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 55,
    "created_at": {
      "seconds": "1663571834",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571834",
      "nanos": 0
    },
    "cname": "#7C0F3B",
    "description": "#7C0F3B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B8B4FF"
    },
    "asset_extend_details": {},
    "material_id": "B8B4FF",
    "material_type": "bgcolor",
    "name": "#B8B4FF",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 56,
    "created_at": {
      "seconds": "1663571835",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571835",
      "nanos": 0
    },
    "cname": "#B8B4FF",
    "description": "#B8B4FF",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E0DAFF"
    },
    "asset_extend_details": {},
    "material_id": "E0DAFF",
    "material_type": "bgcolor",
    "name": "#E0DAFF",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 57,
    "created_at": {
      "seconds": "1663571835",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571835",
      "nanos": 0
    },
    "cname": "#E0DAFF",
    "description": "#E0DAFF",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#6D67D1"
    },
    "asset_extend_details": {},
    "material_id": "6D67D1",
    "material_type": "bgcolor",
    "name": "#6D67D1",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 58,
    "created_at": {
      "seconds": "1663571836",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571836",
      "nanos": 0
    },
    "cname": "#6D67D1",
    "description": "#6D67D1",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#5233C1"
    },
    "asset_extend_details": {},
    "material_id": "5233C1",
    "material_type": "bgcolor",
    "name": "#5233C1",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 59,
    "created_at": {
      "seconds": "1663571837",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571837",
      "nanos": 0
    },
    "cname": "#5233C1",
    "description": "#5233C1",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#A9D3F4"
    },
    "asset_extend_details": {},
    "material_id": "A9D3F4",
    "material_type": "bgcolor",
    "name": "#A9D3F4",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 60,
    "created_at": {
      "seconds": "1663571838",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571838",
      "nanos": 0
    },
    "cname": "#A9D3F4",
    "description": "#A9D3F4",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#342A59"
    },
    "asset_extend_details": {},
    "material_id": "342A59",
    "material_type": "bgcolor",
    "name": "#342A59",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 61,
    "created_at": {
      "seconds": "1663571838",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571838",
      "nanos": 0
    },
    "cname": "#342A59",
    "description": "#342A59",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#7DB3F7"
    },
    "asset_extend_details": {},
    "material_id": "7DB3F7",
    "material_type": "bgcolor",
    "name": "#7DB3F7",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 62,
    "created_at": {
      "seconds": "1663571839",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571839",
      "nanos": 0
    },
    "cname": "#7DB3F7",
    "description": "#7DB3F7",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#1570CA"
    },
    "asset_extend_details": {},
    "material_id": "1570CA",
    "material_type": "bgcolor",
    "name": "#1570CA",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 63,
    "created_at": {
      "seconds": "1663571841",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571841",
      "nanos": 0
    },
    "cname": "#1570CA",
    "description": "#1570CA",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#3889EF"
    },
    "asset_extend_details": {},
    "material_id": "3889EF",
    "material_type": "bgcolor",
    "name": "#3889EF",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 64,
    "created_at": {
      "seconds": "1663571841",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571841",
      "nanos": 0
    },
    "cname": "#3889EF",
    "description": "#3889EF",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#273B6D"
    },
    "asset_extend_details": {},
    "material_id": "273B6D",
    "material_type": "bgcolor",
    "name": "#273B6D",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 65,
    "created_at": {
      "seconds": "1663571842",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571842",
      "nanos": 0
    },
    "cname": "#273B6D",
    "description": "#273B6D",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B1F7FF"
    },
    "asset_extend_details": {},
    "material_id": "B1F7FF",
    "material_type": "bgcolor",
    "name": "#B1F7FF",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 66,
    "created_at": {
      "seconds": "1663571843",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571843",
      "nanos": 0
    },
    "cname": "#B1F7FF",
    "description": "#B1F7FF",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#21BDD5"
    },
    "asset_extend_details": {},
    "material_id": "21BDD5",
    "material_type": "bgcolor",
    "name": "#21BDD5",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 67,
    "created_at": {
      "seconds": "1663571844",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571844",
      "nanos": 0
    },
    "cname": "#21BDD5",
    "description": "#21BDD5",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#59DDED"
    },
    "asset_extend_details": {},
    "material_id": "59DDED",
    "material_type": "bgcolor",
    "name": "#59DDED",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 68,
    "created_at": {
      "seconds": "1663571844",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571844",
      "nanos": 0
    },
    "cname": "#59DDED",
    "description": "#59DDED",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#1994A7"
    },
    "asset_extend_details": {},
    "material_id": "1994A7",
    "material_type": "bgcolor",
    "name": "#1994A7",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 69,
    "created_at": {
      "seconds": "1663571845",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571845",
      "nanos": 0
    },
    "cname": "#1994A7",
    "description": "#1994A7",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#CBEFE4"
    },
    "asset_extend_details": {},
    "material_id": "CBEFE4",
    "material_type": "bgcolor",
    "name": "#CBEFE4",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 70,
    "created_at": {
      "seconds": "1663571846",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571846",
      "nanos": 0
    },
    "cname": "#CBEFE4",
    "description": "#CBEFE4",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#1DA68C"
    },
    "asset_extend_details": {},
    "material_id": "1DA68C",
    "material_type": "bgcolor",
    "name": "#1DA68C",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 71,
    "created_at": {
      "seconds": "1663571847",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571847",
      "nanos": 0
    },
    "cname": "#1DA68C",
    "description": "#1DA68C",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#92CDB8"
    },
    "asset_extend_details": {},
    "material_id": "92CDB8",
    "material_type": "bgcolor",
    "name": "#92CDB8",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 72,
    "created_at": {
      "seconds": "1663571847",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571847",
      "nanos": 0
    },
    "cname": "#92CDB8",
    "description": "#92CDB8",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#10816B"
    },
    "asset_extend_details": {},
    "material_id": "10816B",
    "material_type": "bgcolor",
    "name": "#10816B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 73,
    "created_at": {
      "seconds": "1663571848",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571848",
      "nanos": 0
    },
    "cname": "#10816B",
    "description": "#10816B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#0A513A"
    },
    "asset_extend_details": {},
    "material_id": "0A513A",
    "material_type": "bgcolor",
    "name": "#0A513A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 74,
    "created_at": {
      "seconds": "1663571849",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571849",
      "nanos": 0
    },
    "cname": "#0A513A",
    "description": "#0A513A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E4E6BC"
    },
    "asset_extend_details": {},
    "material_id": "E4E6BC",
    "material_type": "bgcolor",
    "name": "#E4E6BC",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 75,
    "created_at": {
      "seconds": "1663571850",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571850",
      "nanos": 0
    },
    "cname": "#E4E6BC",
    "description": "#E4E6BC",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#77911B"
    },
    "asset_extend_details": {},
    "material_id": "77911B",
    "material_type": "bgcolor",
    "name": "#77911B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 76,
    "created_at": {
      "seconds": "1663571852",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571852",
      "nanos": 0
    },
    "cname": "#77911B",
    "description": "#77911B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#416827"
    },
    "asset_extend_details": {},
    "material_id": "416827",
    "material_type": "bgcolor",
    "name": "#416827",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 77,
    "created_at": {
      "seconds": "1663571853",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571853",
      "nanos": 0
    },
    "cname": "#416827",
    "description": "#416827",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#2F4B29"
    },
    "asset_extend_details": {},
    "material_id": "2F4B29",
    "material_type": "bgcolor",
    "name": "#2F4B29",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 78,
    "created_at": {
      "seconds": "1663571854",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571854",
      "nanos": 0
    },
    "cname": "#2F4B29",
    "description": "#2F4B29",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#A49590"
    },
    "asset_extend_details": {},
    "material_id": "A49590",
    "material_type": "bgcolor",
    "name": "#A49590",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 79,
    "created_at": {
      "seconds": "1663571855",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571855",
      "nanos": 0
    },
    "cname": "#A49590",
    "description": "#A49590",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D1C7C4"
    },
    "asset_extend_details": {},
    "material_id": "D1C7C4",
    "material_type": "bgcolor",
    "name": "#D1C7C4",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 80,
    "created_at": {
      "seconds": "1663571855",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571855",
      "nanos": 0
    },
    "cname": "#D1C7C4",
    "description": "#D1C7C4",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#74645A"
    },
    "asset_extend_details": {},
    "material_id": "74645A",
    "material_type": "bgcolor",
    "name": "#74645A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 81,
    "created_at": {
      "seconds": "1663571856",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571856",
      "nanos": 0
    },
    "cname": "#74645A",
    "description": "#74645A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#57483E"
    },
    "asset_extend_details": {},
    "material_id": "57483E",
    "material_type": "bgcolor",
    "name": "#57483E",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 82,
    "created_at": {
      "seconds": "1663571857",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571857",
      "nanos": 0
    },
    "cname": "#57483E",
    "description": "#57483E",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#C8645E"
    },
    "asset_extend_details": {},
    "material_id": "C8645E",
    "material_type": "bgcolor",
    "name": "#C8645E",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 83,
    "created_at": {
      "seconds": "1663571858",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571858",
      "nanos": 0
    },
    "cname": "#C8645E",
    "description": "#C8645E",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#953B47"
    },
    "asset_extend_details": {},
    "material_id": "953B47",
    "material_type": "bgcolor",
    "name": "#953B47",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 84,
    "created_at": {
      "seconds": "1663571859",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571859",
      "nanos": 0
    },
    "cname": "#953B47",
    "description": "#953B47",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#D38462"
    },
    "asset_extend_details": {},
    "material_id": "D38462",
    "material_type": "bgcolor",
    "name": "#D38462",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 85,
    "created_at": {
      "seconds": "1663571860",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571860",
      "nanos": 0
    },
    "cname": "#D38462",
    "description": "#D38462",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#ECB484"
    },
    "asset_extend_details": {},
    "material_id": "ECB484",
    "material_type": "bgcolor",
    "name": "#ECB484",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 86,
    "created_at": {
      "seconds": "1663571860",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571860",
      "nanos": 0
    },
    "cname": "#ECB484",
    "description": "#ECB484",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#AC6A44"
    },
    "asset_extend_details": {},
    "material_id": "AC6A44",
    "material_type": "bgcolor",
    "name": "#AC6A44",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 87,
    "created_at": {
      "seconds": "1663571861",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571861",
      "nanos": 0
    },
    "cname": "#AC6A44",
    "description": "#AC6A44",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E3CF93"
    },
    "asset_extend_details": {},
    "material_id": "E3CF93",
    "material_type": "bgcolor",
    "name": "#E3CF93",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 88,
    "created_at": {
      "seconds": "1663571862",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571862",
      "nanos": 0
    },
    "cname": "#E3CF93",
    "description": "#E3CF93",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#E7BC4C"
    },
    "asset_extend_details": {},
    "material_id": "E7BC4C",
    "material_type": "bgcolor",
    "name": "#E7BC4C",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 89,
    "created_at": {
      "seconds": "1663571863",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571863",
      "nanos": 0
    },
    "cname": "#E7BC4C",
    "description": "#E7BC4C",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B2B86B"
    },
    "asset_extend_details": {},
    "material_id": "B2B86B",
    "material_type": "bgcolor",
    "name": "#B2B86B",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 90,
    "created_at": {
      "seconds": "1663571864",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571864",
      "nanos": 0
    },
    "cname": "#B2B86B",
    "description": "#B2B86B",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#BDA04F"
    },
    "asset_extend_details": {},
    "material_id": "BDA04F",
    "material_type": "bgcolor",
    "name": "#BDA04F",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 91,
    "created_at": {
      "seconds": "1663571864",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571864",
      "nanos": 0
    },
    "cname": "#BDA04F",
    "description": "#BDA04F",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#768A60"
    },
    "asset_extend_details": {},
    "material_id": "768A60",
    "material_type": "bgcolor",
    "name": "#768A60",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 92,
    "created_at": {
      "seconds": "1663571865",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571865",
      "nanos": 0
    },
    "cname": "#768A60",
    "description": "#768A60",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#3F5D11"
    },
    "asset_extend_details": {},
    "material_id": "3F5D11",
    "material_type": "bgcolor",
    "name": "#3F5D11",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 93,
    "created_at": {
      "seconds": "1663571866",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571866",
      "nanos": 0
    },
    "cname": "#3F5D11",
    "description": "#3F5D11",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#118275"
    },
    "asset_extend_details": {},
    "material_id": "118275",
    "material_type": "bgcolor",
    "name": "#118275",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 94,
    "created_at": {
      "seconds": "1663571867",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571867",
      "nanos": 0
    },
    "cname": "#118275",
    "description": "#118275",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#5F918A"
    },
    "asset_extend_details": {},
    "material_id": "5F918A",
    "material_type": "bgcolor",
    "name": "#5F918A",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 95,
    "created_at": {
      "seconds": "1663571867",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571867",
      "nanos": 0
    },
    "cname": "#5F918A",
    "description": "#5F918A",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#216D60"
    },
    "asset_extend_details": {},
    "material_id": "216D60",
    "material_type": "bgcolor",
    "name": "#216D60",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 96,
    "created_at": {
      "seconds": "1663571868",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571868",
      "nanos": 0
    },
    "cname": "#216D60",
    "description": "#216D60",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#7FB5C1"
    },
    "asset_extend_details": {},
    "material_id": "7FB5C1",
    "material_type": "bgcolor",
    "name": "#7FB5C1",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 97,
    "created_at": {
      "seconds": "1663571869",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571869",
      "nanos": 0
    },
    "cname": "#7FB5C1",
    "description": "#7FB5C1",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#60B1B5"
    },
    "asset_extend_details": {},
    "material_id": "60B1B5",
    "material_type": "bgcolor",
    "name": "#60B1B5",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 98,
    "created_at": {
      "seconds": "1663571870",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571870",
      "nanos": 0
    },
    "cname": "#60B1B5",
    "description": "#60B1B5",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#94AFC8"
    },
    "asset_extend_details": {},
    "material_id": "94AFC8",
    "material_type": "bgcolor",
    "name": "#94AFC8",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 99,
    "created_at": {
      "seconds": "1663571871",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571871",
      "nanos": 0
    },
    "cname": "#94AFC8",
    "description": "#94AFC8",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#587BB2"
    },
    "asset_extend_details": {},
    "material_id": "587BB2",
    "material_type": "bgcolor",
    "name": "#587BB2",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 100,
    "created_at": {
      "seconds": "1663571872",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571872",
      "nanos": 0
    },
    "cname": "#587BB2",
    "description": "#587BB2",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#364460"
    },
    "asset_extend_details": {},
    "material_id": "364460",
    "material_type": "bgcolor",
    "name": "#364460",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 101,
    "created_at": {
      "seconds": "1663571873",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571873",
      "nanos": 0
    },
    "cname": "#364460",
    "description": "#364460",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#987F98"
    },
    "asset_extend_details": {},
    "material_id": "987F98",
    "material_type": "bgcolor",
    "name": "#987F98",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 102,
    "created_at": {
      "seconds": "1663571874",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571874",
      "nanos": 0
    },
    "cname": "#987F98",
    "description": "#987F98",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#C1A7BC"
    },
    "asset_extend_details": {},
    "material_id": "C1A7BC",
    "material_type": "bgcolor",
    "name": "#C1A7BC",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 103,
    "created_at": {
      "seconds": "1663571874",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571874",
      "nanos": 0
    },
    "cname": "#C1A7BC",
    "description": "#C1A7BC",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#6A3E59"
    },
    "asset_extend_details": {},
    "material_id": "6A3E59",
    "material_type": "bgcolor",
    "name": "#6A3E59",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 104,
    "created_at": {
      "seconds": "1663571875",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663571875",
      "nanos": 0
    },
    "cname": "#6A3E59",
    "description": "#6A3E59",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#176B8D"
    },
    "asset_extend_details": {},
    "material_id": "176B8D",
    "material_type": "bgcolor",
    "name": "#176B8D",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 105,
    "created_at": {
      "seconds": "1663571870",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663579153",
      "nanos": 0
    },
    "cname": "#176B8D",
    "description": "#176B8D",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "color": "#B6C737"
    },
    "asset_extend_details": {},
    "material_id": "B6C737",
    "material_type": "bgcolor",
    "name": "#B6C737",
    "cover_url": "https://zenvideo.gtimg.com/xy/zen_video/NoThumb.png/200",
    "status": 1,
    "priority": 106,
    "created_at": {
      "seconds": "1663571851",
      "nanos": 0
    },
    "updated_at": {
      "seconds": "1663579210",
      "nanos": 0
    },
    "cname": "#B6C737",
    "description": "#B6C737",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  }
]

export const sourceMaterial = [
	{
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/SsQUxuoD.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_zewendong_1",
		"material_type": "video",
		"name": "视频",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/Y2IogDpn.jpg",
		"status": 1,
		"priority": 4,
		"created_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"cname": "简约时尚",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	}, {
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/SsQUxuoD.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_zewendong_2",
		"material_type": "audio",
		"name": "音频",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/Y2IogDpn.jpg",
		"status": 1,
		"priority": 4,
		"created_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"cname": "简约时尚",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	}, {
		"cate": [],
		"asset_details": {
			"url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/url/SsQUxuoD.jpg"
		},
		"asset_extend_details": {},
		"material_id": "bg_zewendong_3",
		"material_type": "picture",
		"name": "图片",
		"cover_url": "https://zenvideo.gtimg.com/xy/zen_video/bgimg/thumb/Y2IogDpn.jpg",
		"status": 1,
		"priority": 4,
		"created_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"updated_at": {
			"seconds": "1691134081",
			"nanos": 0
		},
		"cname": "简约时尚",
		"description": "",
		"custom_id": "",
		"preview": "",
		"collect_id": "",
		"m_center_prefix": "",
		"start": "0",
		"end": "0",
		"now": "0"
	}
]

export const materialMusics = [
  {
    "cate": [],
    "asset_details": {
      "authority_status": "0",
      "wave_url": "",
      "album_name": "翻唱歌曲合集",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000001Mf4Ic1aNYYK_1.jpg",
      "author": "双笙 (陈元汐)",
      "duration": "231000",
      "singer_name": "双笙 (陈元汐)",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200000HRBas1Z3rxd.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Da538dd31c2e208b6abe36b2f92841952831a54fe",
      "collect_tag": "music"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000K4Udp3IBMd2",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000001Mf4Ic1aNYYK_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "桃花笑",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "singer_name": "等什么君",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200003KS0884VZMqe.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Dd897ec04a001f4f8c34cf6c955d8826874becbfd",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_003izpqf19Dwps.json",
      "album_name": "辞九门回忆",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000001Jegbz00ePg5_2.jpg",
      "author": "等什么君",
      "authority_status": "0",
      "duration": "240000"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_003izpqf19Dwps",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000001Jegbz00ePg5_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "辞九门回忆",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_0022kFzj4O1OxJ.json",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200004BHwfH4RPFRU.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D69a72cdc48e20ec227dcf8d75ac487ec30d4edc0",
      "album_name": "辞·九门回忆",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000002phjAD2TnyBz_1.jpg",
      "author": "冰幽/解忧草",
      "authority_status": "0",
      "duration": "241000",
      "singer_name": "冰幽/解忧草"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_0022kFzj4O1OxJ",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000002phjAD2TnyBz_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "辞·九门回忆",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "author": "买辣椒也用券",
      "authority_status": "0",
      "singer_name": "买辣椒也用券",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_003hKob536i6FA.json",
      "collect_tag": "music",
      "album_name": "起风了",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200002WpoqG1wDTUa.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Dc184e1eca33c1521b3abc0bb82fdefad3a6f6eea",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000002u9Brw2zqK6N_2.jpg",
      "duration": "325000"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_003hKob536i6FA",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000002u9Brw2zqK6N_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "起风了",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "duration": "258000",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200000OhmMs3I976W.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D777fab4b887251e1c0a4c14d71e643e0d976fcb8",
      "collect_tag": "music",
      "album_name": "最美的情缘",
      "authority_status": "0",
      "singer_name": "魏新雨",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_001rcH833YUuH8.json",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000003eSyQ30xWRaG_1.jpg",
      "author": "魏新雨"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001rcH833YUuH8",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000003eSyQ30xWRaG_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "最美的情缘",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "duration": "237000",
      "singer_name": "吴伟杰",
      "url": "//isure6.stream.qqmusic.qq.com/C200000pIGh32hvOdj.m4a?guid=2000000025&vkey=14D1299AD9DCA5BA785A0638E7B9E1A7B870A36E705D65A2DE4655F4312E69B20C9C895CE71A6F48510CCEACB88CC9C95C8ADFCDE095EB7F&uin=0&fromtag=20025&src=C2000033mcOd3723uU.m4a&trace=e2b493dcf417ee2",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_000ZgrB5487FKL.json",
      "collect_tag": "music",
      "author": "吴伟杰",
      "authority_status": "0",
      "album_name": "心跳",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000001gZITD1ZMJIv_1.jpg"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000ZgrB5487FKL",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000001gZITD1ZMJIv_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "心跳",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "duration": "60000",
      "url": "",
      "wave_url": "",
      "album_name": "",
      "album_pic": "//tvcpicture.qpic.cn/music/412830d8d58cd3a1e30d90ca5512a38d/412830d8d58cd3a1e30d90ca5512a38d.jpg",
      "author": "杨宗纬",
      "authority_status": "3",
      "singer_name": "杨宗纬"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_dIEVDr9bdU9hf",
    "material_type": "music",
    "name": "",
    "cover_url": "//tvcpicture.qpic.cn/music/412830d8d58cd3a1e30d90ca5512a38d/412830d8d58cd3a1e30d90ca5512a38d.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "其实都没有",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_name": "张开双腿使劲摇",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000M88qq3khnrE_1.jpg",
      "authority_status": "0",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200002luuH74E1IMK.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3De3fc4d5efb887df46e5abcdf050480e855d6372e",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_002qMLr52GmfFe.json",
      "author": "7爷",
      "duration": "197000",
      "singer_name": "7爷"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_002qMLr52GmfFe",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000M88qq3khnrE_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "是时候表演真正的技术了",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "album_name": "写给父亲的散文诗",
      "author": "曹佳颖",
      "wave_url": "",
      "collect_tag": "music",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000003VfUaI3UHZ8n_1.jpg",
      "authority_status": "0",
      "duration": "227000",
      "singer_name": "曹佳颖",
      "url": "//isure6.stream.qqmusic.qq.com/C200001CtBaN1ZvHTR.m4a?guid=2000000025&vkey=E8D00E07CAE62712B59A649944BC7D560E51FBB3F8CF8CE0D77C90462F8CEE4D764E1AE6685E4FD47B0831579C5634B3E4ECCE8131F5AA03&uin=0&fromtag=20025&trace=79cfc461a070df66"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001CtBaN1ZvHTR",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000003VfUaI3UHZ8n_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "父亲写的散文诗",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "author": "菲儿",
      "authority_status": "0",
      "singer_name": "菲儿",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200003Uskrt0jOAyW.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D53255694a5ee6c56fbf5bde2940d26b84f6c9362",
      "wave_url": "",
      "album_pic": "//qzonestyle.gtimg.cn/aoi/sola/20190620142502_8lKP2SUiUW.png",
      "album_name": "",
      "duration": "320000",
      "collect_tag": "music"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_00093GCL1pXsAC",
    "material_type": "music",
    "name": "",
    "cover_url": "//qzonestyle.gtimg.cn/aoi/sola/20190620142502_8lKP2SUiUW.png",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "我的楼兰",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "album_name": "是你",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M0000020geAF0eKm7i_1.jpg",
      "authority_status": "0",
      "duration": "216000",
      "singer_name": "吴海啸Tsunami/扬科YANGK",
      "collect_tag": "music",
      "author": "吴海啸Tsunami/扬科YANGK",
      "url": "//isure6.stream.qqmusic.qq.com/C200002f0bxO2w6twe.m4a?guid=2000000025&vkey=F17997C03E0181CF693B5420C2C2F720D940089C4FF18195BD5319F2B01EFA4DB8DA1AC8C21A6E35BE8CD85A3E884E7044ABCE4835FCA74E&uin=0&fromtag=20025&src=C200003z8Z8316O61l.m4a&trace=8c08e8e3fe4b022",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_000P1BWt0LfSKS.json"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000P1BWt0LfSKS",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M0000020geAF0eKm7i_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "是你",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "author": "Mr.V",
      "authority_status": "0",
      "singer_name": "Mr.V",
      "url": "//tvcqqmusicectype.gtimg.cn/music/d537ef68835dcc1e2e7ce481ba16e0bd.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118272%3B1709132672%26q-key-time%3D1709118272%3B1709132672%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3De7919d77203cfb658d002ff235667a6eb80f7ed4",
      "album_name": "",
      "album_pic": "//shootmedia.qpic.cn/music/5b9f9bb6a4de49e1ce3a1e1d890a161c.jpg",
      "duration": "8000",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_weishi_GpN48QfgoBGfq.json"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_GpN48QfgoBGfq",
    "material_type": "music",
    "name": "",
    "cover_url": "//shootmedia.qpic.cn/music/5b9f9bb6a4de49e1ce3a1e1d890a161c.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "神经病之歌 (改编)",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "author": "浩然H.R",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200002ARYeR2qgMg7.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3De2f063d2540a0200831c6ea335c6fa4dc3995052",
      "wave_url": "",
      "album_name": "年少的你啊",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000xZc9K4YEt5Z_3.jpg",
      "authority_status": "0",
      "duration": "180000",
      "singer_name": "浩然H.R",
      "collect_tag": "music"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_004ZHzIF0f0goH",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000xZc9K4YEt5Z_3.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "年少的你啊",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_name": "桃花雪",
      "author": "风小筝",
      "authority_status": "0",
      "duration": "208000",
      "url": "//isure6.stream.qqmusic.qq.com/C200001AhqWd0oJesf.m4a?guid=2000000025&vkey=9A4A8FEF7CD91B85ADC9A8D4E020B36973F3E01D1F2C08A0DB1CD2EE5287FCC19218E8D60DBD12757D2FE7E5F5C9CE26431DF8047720B59F&uin=0&fromtag=20025&src=C200000qmdJY12xDca.m4a&trace=6303ae8131e0c596",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000001YJS0M1KUPHB_1.jpg",
      "singer_name": "风小筝",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_000ab8YG06aaib.json"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000ab8YG06aaib",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000001YJS0M1KUPHB_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "桃花雪",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "url": "//isure6.stream.qqmusic.qq.com/C200004SE9mV19YFyJ.m4a?guid=2000000025&vkey=927CFE102D66B84330FD2FB5654D91C0911EF704A6D60052DCA85EAB722D308B2BC7DAF7617E057D32F38CF9AAD554B939F654EDA36009A2&uin=0&fromtag=20025&src=C200000fwpN83YhItc.m4a&trace=e2b493dcf417ee2",
      "wave_url": "",
      "author": "程小小",
      "authority_status": "0",
      "duration": "243000",
      "singer_name": "程小小",
      "collect_tag": "music",
      "album_name": "桃花酿",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000r1wCL3XtZ73_1.jpg"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000fwpN83YhItc",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000r1wCL3XtZ73_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "桃花酿",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000Laplj45h7ft_1.jpg",
      "author": "吴樾",
      "authority_status": "0",
      "url": "//isure6.stream.qqmusic.qq.com/C2000036ewT22uLGcD.m4a?guid=2000000025&vkey=39942CBB73FA471C233D123EBE380362BE93E9963ED152EC96F93A96A0DE84D5639E0B907C376B249A3EB92E49DC172AA25181D3AD5B7B87&uin=0&fromtag=20025&src=C200000r2FZK2pFDCx.m4a&trace=e2b493dcf417ee2",
      "album_name": "月亮代表我的心",
      "duration": "200000",
      "singer_name": "吴樾",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_001teIOD44TjCn.json",
      "collect_tag": "music"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001teIOD44TjCn",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000Laplj45h7ft_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "月亮代表我的心",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "duration": "262000",
      "url": "//isure6.stream.qqmusic.qq.com/C200001NquRs25fbTj.m4a?guid=2000000025&vkey=C5DA3CFF1C321BE92804455E29B1B368080032E70491DD2DE5A5FFC5BB5D85882F0FA0A38936A10B96AC9A1BB8954F5C1A6CA1E6AF6B4839&uin=0&fromtag=20025&src=C200002pNXpi3L9U3x.m4a&trace=32c3c0aa4d2a4aed",
      "collect_tag": "music",
      "album_name": "太阳",
      "authority_status": "0",
      "singer_name": "邱振哲",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_0020EsCs3jHwB8.json",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000003UYXH30UI0jl_2.jpg",
      "author": "邱振哲"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_0020EsCs3jHwB8",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000003UYXH30UI0jl_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "太阳",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_name": "小城夏天",
      "author": "LBI利比",
      "authority_status": "0",
      "singer_name": "LBI利比",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200003J7504230Eij.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Ded3f7e989a70528df77c947df36a95163b4c619d",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000004CvHyt4dW543_2.jpg",
      "duration": "173000",
      "wave_url": ""
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_002ulOzb02Xbdo",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000004CvHyt4dW543_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "小城夏天",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "url": "//isure6.stream.qqmusic.qq.com/C200000qg0C93qB381.m4a?guid=2000000025&vkey=49A7412F10ADBA22A3CFE6E13A7A735574083C2C7DD447D3457EE2314F32DE3E7787BF41C0650C5F1C5C2316F22806272DE704A63E6FE776&uin=0&fromtag=20025&trace=1235095e7f9edfee",
      "collect_tag": "music",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000k3rr93xMoCt_1.jpg",
      "author": "徐薇",
      "authority_status": "0",
      "duration": "298000",
      "singer_name": "徐薇",
      "album_name": "追晚风的人",
      "wave_url": ""
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_002rQrM01BtlT5",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000k3rr93xMoCt_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "追晚风的人",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "singer_name": "怪阿姨",
      "collect_tag": "music",
      "album_name": "羡慕风羡慕雨",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000003Jd8AP1LaI4s_2.jpg",
      "author": "怪阿姨",
      "authority_status": "0",
      "duration": "199000",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200003Komuw1FtzOk.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D385b14ffa2e640c97f3b2c06df906f3f7212e8e2",
      "wave_url": ""
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_003Komuw1FtzOk",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000003Jd8AP1LaI4s_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "羡慕风羡慕雨",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "album_pic": "//shootmedia.qpic.cn/music/4395d101b41c44103899ac533734e4cc.png",
      "author": "Matteino Dj & Alessio Carli",
      "authority_status": "0",
      "singer_name": "Matteino Dj & Alessio Carli",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_weishi_8uVsRNKnvntbv.json",
      "collect_tag": "music",
      "album_name": "",
      "duration": "270000",
      "url": "//tvcqqmusicectype.gtimg.cn/music/d13d7654467e67f85d3b6243293ca146.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118272%3B1709132672%26q-key-time%3D1709118272%3B1709132672%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D707780bf31e2e22dc316df1c22005cd005ea97b9"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_8uVsRNKnvntbv",
    "material_type": "music",
    "name": "",
    "cover_url": "//shootmedia.qpic.cn/music/4395d101b41c44103899ac533734e4cc.png",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "You Said",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "duration": "143000",
      "singer_name": "陈丙",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200000m9qFV3N09it.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Dfafa94b931f865390380f7b8a8843154da30f543",
      "album_name": "了解一下",
      "author": "陈丙",
      "authority_status": "0",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_000m9qFV3N09it.json",
      "collect_tag": "music",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000YJJXn4FQTwe_1.jpg"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_000m9qFV3N09it",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000YJJXn4FQTwe_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "嘟嘟嘟",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "duration": "30000",
      "url": "//tvcqqmusicectype.gtimg.cn/music/0de25336200bc69a92b18756fb193344/0de25336200bc69a92b18756fb193344.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118272%3B1709132672%26q-key-time%3D1709118272%3B1709132672%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D22a0ef92f0dadf288254fa61a32b3814ce27277e",
      "wave_url": "",
      "collect_tag": "music",
      "album_name": "",
      "author": "张津涤",
      "album_pic": "//tvcpicture.qpic.cn/music/27c583ff16031ef4c51cdb6ed17a4b1d/27c583ff16031ef4c51cdb6ed17a4b1d.jpg",
      "authority_status": "0",
      "singer_name": "张津涤"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_vjy4604KhR1fG",
    "material_type": "music",
    "name": "",
    "cover_url": "//tvcpicture.qpic.cn/music/27c583ff16031ef4c51cdb6ed17a4b1d/27c583ff16031ef4c51cdb6ed17a4b1d.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "万疆",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "album_name": "",
      "authority_status": "0",
      "singer_name": "Crazy Donkey",
      "url": "//tvcqqmusicectype.gtimg.cn/music/47a784dd4def88c40a733a0009a6ebff.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118272%3B1709132672%26q-key-time%3D1709118272%3B1709132672%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D905c692b6df8fbb161223675861091d50b94c92a",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_weishi_7GTNDNs4sNjNf.json",
      "collect_tag": "music",
      "album_pic": "//tvcpicture.qpic.cn/music/c106596f295f075da250ed4f401251ee.jpg",
      "author": "Crazy Donkey",
      "duration": "217000"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_7GTNDNs4sNjNf",
    "material_type": "music",
    "name": "",
    "cover_url": "//tvcpicture.qpic.cn/music/c106596f295f075da250ed4f401251ee.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "Morsmordre",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "author": "任素汐",
      "authority_status": "0",
      "album_name": "王招君",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000000jg17x3cKA3S_1.jpg",
      "duration": "255000",
      "singer_name": "任素汐",
      "url": "//isure6.stream.qqmusic.qq.com/C2000022eUhF3YLbV1.m4a?guid=2000000025&vkey=EF5B4945B105C5025E3E9DE20938C05128354B3603905384876CCE8B7F87EBDC537896026CAD6AE2C8715AB470ED40DEF66C26A3A72D2425&uin=0&fromtag=20025&trace=7ef186e27cbc9cc1",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_001D51640M6ZeR.json"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001D51640M6ZeR",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000000jg17x3cKA3S_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "王招君",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_name": "",
      "duration": "256000",
      "singer_name": "良一",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_weishi_GAackejzg8IS0.json",
      "album_pic": "//shootmedia.qpic.cn/music/3c12cad4935dd6a751dd619c40c78ebd.jpg",
      "author": "良一",
      "authority_status": "0",
      "url": "//tvcqqmusicectype.gtimg.cn/music/9c82eeafb0ba7cda231b2a00b5e40224.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118272%3B1709132672%26q-key-time%3D1709118272%3B1709132672%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D8efeca32d20d962202c4c3dfb22a832a6245132b"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_weishi_GAackejzg8IS0",
    "material_type": "music",
    "name": "",
    "cover_url": "//shootmedia.qpic.cn/music/3c12cad4935dd6a751dd619c40c78ebd.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "我呒惊",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_name": "看得最远的地方",
      "author": "张愉",
      "authority_status": "0",
      "duration": "244000",
      "singer_name": "张愉",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200003ecoiQ4YSGC5.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3Df42637ddf96449a77b5c77fb3272f852484a29c5",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000003CNXdi0v6ffz_1.jpg",
      "wave_url": ""
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_003ecoiQ4YSGC5",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000003CNXdi0v6ffz_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "看得最远的地方",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C200000gXuWt3xpvhW.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D628b0ddd4c5dcbfdad2692ef322bb82235ebbe00",
      "wave_url": "",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000004DkFMj1jXLXX_2.jpg",
      "singer_name": "玖壹壹",
      "author": "玖壹壹",
      "authority_status": "0",
      "duration": "195000",
      "collect_tag": "music",
      "album_name": "来个蹦蹦(玖壹壹 Ft.Ella陈嘉桦)"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001QzXJP2lepi6",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000004DkFMj1jXLXX_2.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "来个蹦蹦",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "collect_tag": "music",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000001PGZ5a4333Rw_1.jpg",
      "author": "徐梦圆",
      "authority_status": "0",
      "singer_name": "徐梦圆",
      "album_name": "在你身边",
      "duration": "220000",
      "url": "//isure6.stream.qqmusic.qq.com/C2000037LkVm02MUKT.m4a?guid=2000000025&vkey=85B6B4437B0B34712CD4AEF078BB08E9158AC6EC32923674E44A3A91D58B3E59340B5DF63A4D64ED6CED93F421FAB0355B2C44552E02C4BF&uin=0&fromtag=20025&src=C200000K4Nnf2OS8SJ.m4a&trace=e2b493dcf417ee2",
      "wave_url": "//zenvideo-pro.gtimg.com/material/audio_material/audio_001777dx17YGFp.json"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_001777dx17YGFp",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000001PGZ5a4333Rw_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "在你身边",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  },
  {
    "cate": [],
    "asset_details": {
      "singer_name": "TANGRAM",
      "wave_url": "",
      "collect_tag": "music",
      "album_name": "陪在你身边",
      "author": "TANGRAM",
      "url": "//tvcqqmusicectype.gtimg.cn/qqmusicectype/C2000008CN773M28YJ.m4a?sign=q-sign-algorithm%3Dsha1%26q-ak%3DPnRHmOkbUzkfQgOR3YC0ACL4%26q-sign-time%3D1709118000%3B1709290800%26q-key-time%3D1709118000%3B1709290800%26q-header-list%3Dhost%26q-url-param-list%3D%26q-signature%3D70ae0d13802557e1e26a5337245933d8eb96a5fe",
      "album_pic": "//y.gtimg.cn/music/photo_new/T002R120x120M000002V6kYC0yHzAB_1.jpg",
      "authority_status": "0",
      "duration": "0"
    },
    "asset_extend_details": {},
    "material_id": "m_center_audio_0008CN773M28YJ",
    "material_type": "music",
    "name": "",
    "cover_url": "//y.gtimg.cn/music/photo_new/T002R120x120M000002V6kYC0yHzAB_1.jpg",
    "status": 1,
    "priority": 0,
    "created_at": null,
    "updated_at": null,
    "cname": "陪在你身边",
    "description": "",
    "custom_id": "",
    "preview": "",
    "collect_id": "",
    "m_center_prefix": "",
    "start": "0",
    "end": "0",
    "now": "0"
  }
]
